<script>
import capitalize from 'lodash/capitalize'
import { formatDate } from '@lib/utils/format-date'
import formatDollar from '@lib/utils/format-dollar'
import { mapGetters } from 'vuex'

export default {
  name: 'PaymentDetails',
  props: {
    payment: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapGetters('me', [
      'canUpdateSettings',
    ]),
  },
  methods: {
    capitalize,
    formatDate,
    formatDollar,
    onEdit() {
      this.$router.push({
        name: 'payment-settings',
        params: {
          edit: 'edit',
        },
      })
    },
  },
}
</script>

<template>
  <data-box
    header="eWallet cash out rules"
    :status="null"
  >
    <template slot="buttons">
      <el-button
        v-if="canUpdateSettings"
        type="primary"
        class="el-button--wide"
        @click="onEdit"
      >
        Edit
      </el-button>
    </template>
    <data-list>
      <dt>Minimum Amount</dt>
      <dd>{{ formatDollar(payment.cashOutLimit) }}</dd>
    </data-list>
  </data-box>
</template>
